export class AddOnHistoryItem{
    ProductName: string;
    StartDate: Date;
    EndDate: Date;
    Status: string;
    AddOnType: string;

    public static FixDates(item: AddOnHistoryItem) {
        item.StartDate = new Date(item.StartDate);
        item.EndDate = new Date(item.EndDate);
    }

}
export class AddOnHistoryItemArray extends Array<AddOnHistoryItem>  {

    constructor(...items: AddOnHistoryItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AddOnHistoryItemArray.prototype);
    }

    public static FixDates(items: AddOnHistoryItemArray) {
        items.forEach(x => AddOnHistoryItem.FixDates(x));
    }
}
